import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ExistingUser.css';

const ExistingUser = () => {
  const navigate = useNavigate();

  const handleYesClick = () => {
    navigate('/registration'); // Navigate to Login if "Yes"
  };

  const handleNoClick = () => {
    navigate('/registration'); // Navigate to Registration if "No"
  };

  return (
    <div className="existing-user-container">
      <h1>Are you an existing user?</h1>
      <div className="button-container">
        <button className="btn" onClick={handleYesClick}>Yes</button>
        <button className="btn" onClick={handleNoClick}>No</button>
      </div>
    </div>
  );
};

export default ExistingUser;
